import { Descriptions, Spin, Typography } from 'antd';
import React from 'react';
import { useInspeccionContext } from '../../../../context/inspeccion-context';

const { Title, Paragraph, Text } = Typography;
const descriptionProps = {
  style: { paddingTop: 24 },
  column: 1,
  size: 'small',
  bordered: true,
  labelStyle: { width: 100 }
};
const LandingPage = ({ title }) => {
  const { inspeccion, loading } = useInspeccionContext();

  return (
    <div style={{ textAlign: 'left' }}>
      <div style={{ paddingTop: 20 }}>
        <Title level={3} align="center">
          {title}
        </Title>
      </div>
      <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
        <div className="content" />
      </Spin>
      {!loading && (
        <>
          <Descriptions title="Asegurado" {...descriptionProps}>
            <Descriptions.Item label="Nombre">
              {inspeccion?.solicitud?.cotizacion?.persona.nombres || ''}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions title="Vehículo" {...descriptionProps}>
            <Descriptions.Item label="Marca">
              {inspeccion?.solicitud?.cotizacion?.vehiculo.marca.descripcion ||
                ''}
            </Descriptions.Item>
            <Descriptions.Item label="Modelo">
              {inspeccion?.solicitud?.cotizacion?.vehiculo.modelo.descripcion ||
                ''}
            </Descriptions.Item>
            <Descriptions.Item label="Chapa">
              {inspeccion?.solicitud?.cotizacion?.vehiculo.chapa || ''}
            </Descriptions.Item>
          </Descriptions>
        </>
      )}
      <br />
      <Title level={4}>
        Para activar la cobertura favor realizar la inspección siguiendo las
        instrucciones:
      </Title>

      <Paragraph>
        <ol>
          <li>Aceptar mantener activada la ubicación</li>
          <li>Tomar las Fotografías con buena iluminación</li>
          <li>
            Captar la <Text strong>totalidad</Text> del vehículo
          </li>
        </ol>
      </Paragraph>
    </div>
  );
};

export default LandingPage;
